<template>
  <div class="bcb-campaign-customer-list w-100">
    <basic-subheader>
      <template v-slot:actions>
        <!-- Bộ lọc dropdown -->
        <b-dropdown
          id="bcb-customer-filter"
          class="dropdown-form-filter"
          no-caret
          right
        >
          <template #button-content>
            <span class="svg-icon">
              <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
            </span>
            Bộ lọc
          </template>
          <h6 class="d-flex align-items-center mb-0 p-4">
            <span class="svg-icon mr-3">
              <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
            </span>
            Bộ lọc
          </h6>
          <b-dropdown-divider />
          <b-dropdown-form>
            <b-container class="p-0">
              <b-row>
                <b-col cols="4">
                  <basic-input
                    label="Họ và tên"
                    placeholder="Nhập họ tên khách hàng"
                    name="fullName"
                    :value.sync="filter.fullName"
                  />
                </b-col>
                <b-col cols="4">
                  <basic-input
                    label="Số điện thoại"
                    placeholder="Nhập số điện thoại"
                    name="phone"
                    :value.sync="filter.phone"
                  />
                </b-col>
                <b-col cols="4">
                  <basic-select
                    label="Trạng thái"
                    placeholder="Tất cả trạng thái"
                    name="status"
                    :options="statusOptions"
                    track-by="value"
                    value-label="text"
                    :value.sync="filter.status"
                  />
                </b-col>
              </b-row>
            </b-container>
          </b-dropdown-form>
          <b-dropdown-divider />
          <div class="d-flex align-items-center justify-content-lg-end m-0 p-4">
            <b-button class="btn ml-2" href="#" tabindex="0" @click="resetFilter">
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/refresh-cw.svg" />
              </span>
              Reset bộ lọc
            </b-button>
            <b-button class="btn ml-2" href="#" tabindex="0" @click="searchRequest">
              <span class="svg-icon">
                <inline-svg src="/media/svg/icons/Neolex/Basic/filter.svg" />
              </span>
              Lọc dữ liệu
            </b-button>
          </div>
        </b-dropdown>
      </template>
    </basic-subheader>

    <b-overlay :show="loading">
      <b-container fluid class="bcb-campaign-customer-list__body mb-6 mt-6">
        <b-row>
          <b-col>
            <div class="card card-custom gutter-b">
              <div class="card-body mt-0">
                <template-table
                  :column="columns"
                  :data="items"
                  :paging="paging"
                  :select-action="false"
                  :search-action="false"
                  :table-action="true"
                  @change-page="onChangePage"
                  @search="searchRequest"
                  @reset="resetFilter"
                >
                  <template #body="{ item }">
                    <td>
                      <span class="font-weight-bold text-dark">
                        {{ item.fullName || item.name || '—' }}
                      </span>
                    </td>
                    <td>{{ item.phone || '—' }}</td>
                    <td>{{ item.campaignName || '—' }}</td>
                    <td>
                      <span class="status-badge" :style="statusStyle(item.status)">
                        {{ statusLabel(item.status) }}
                      </span>
                    </td>
                    <td>{{ formatDate(item.createDatetime) }}</td>
                  </template>
                  <template #action="{ item }">
                    <action-dropdown
                      :value="item"
                      :show_view="true"
                      :show_copy="false"
                      :show_edit="false"
                      :show_delete="false"
                      @view="viewItem"
                    />
                  </template>
                </template-table>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import { CUSTOMER_STATUS, CUSTOMER_STATUS_WORKFLOW_OPTIONS } from './constants/index.js';

export default {
  name: 'BcbCampaignCustomerList',
  data() {
    return {
      loading: false,
      items: [],
      filter: {
        fullName: null,
        phone: null,
        status: null,
      },
      statusOptions: CUSTOMER_STATUS_WORKFLOW_OPTIONS,
      paging: { page: 1, pageSize: 10, total: 0 },
      columns: [
        { key: 'fullName', label: 'Họ tên', style: 'width: 25%' },
        { key: 'phone', label: 'Số điện thoại', style: 'width: 15%' },
        { key: 'campaignName', label: 'Chiến dịch', style: 'width: 25%' },
        { key: 'status', label: 'Trạng thái', style: 'width: 15%' },
        { key: 'createDatetime', label: 'Ngày tạo', style: 'width: 15%' },
      ],
    };
  },
  computed: {
    searchParams() {
      const p = {
        page: this.paging.page,
        size: this.paging.pageSize,
      };
      if (this.filter.fullName) p.fullName = this.filter.fullName;
      if (this.filter.phone) p.phone = this.filter.phone;
      if (this.filter.status?.value != null) p.status = this.filter.status.value;
      return p;
    },
  },
  watch: {
    'paging.page'() { this.loadData(); },
    'paging.pageSize'() { this.paging.page = 1; this.loadData(); },
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const res = await this.$api.get('/BcbCampaignCustomer', { params: this.searchParams });
        const raw = res?.data ?? res;
        const list = raw?.items ?? raw?.data?.items ?? (Array.isArray(raw) ? raw : []);
        this.items = list;
        this.paging.total = raw?.total ?? raw?.data?.total ?? list.length;
      } catch (e) {
        this.$toastr.e({ title: 'Lỗi', msg: e?.message || 'Không thể tải danh sách khách hàng.' });
      } finally {
        this.loading = false;
      }
    },
    searchRequest() {
      this.paging.page = 1;
      this.loadData();
      document.body.click();
    },
    resetFilter() {
      this.filter = { fullName: null, phone: null, status: null };
      this.paging.page = 1;
      this.loadData();
      document.body.click();
    },
    onChangePage(page) {
      this.paging.page = page;
      this.loadData();
    },
    viewItem(item) {
      const customerId = item.id || item.customerId || item.bcbCampaignCustomerId;
      if (!customerId) {
        this.$toastr.e({ title: 'Lỗi', msg: 'Không tìm thấy ID khách hàng.' });
        return;
      }
      const campaignId = item.campaignId || null;
      if (campaignId) {
        // Route có campaignId trong path → resolvedCampaignId sẽ hoạt động đúng
        this.$router.push({
          name: 'bcb-campaign-customer-detail',
          params: { campaignId: String(campaignId), customerId: String(customerId) },
        });
      } else {
        this.$router.push({
          name: 'bcb-customer-view',
          params: { customerId: String(customerId) },
        });
      }
    },
    statusLabel(status) {
      return CUSTOMER_STATUS[status]?.label || (status ? String(status) : '—');
    },
    statusStyle(status) {
      const cfg = CUSTOMER_STATUS[status];
      return {
        backgroundColor: cfg?.bg || '#F1EFE8',
        color: cfg?.color || '#444441',
      };
    },
    formatDate(val) {
      if (!val) return '—';
      return this.$moment.unix(val).utcOffset('+07:00').format('DD/MM/YYYY');
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-form-filter {
  .dropdown-menu {
    .container {
      width: 700px;
    }
  }
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
}
</style>
